<template>
  <div>
    <div class="around-fade"></div>

    <div class="zone-modal">
      <CloseModalButton :on-click="closeAccountModal"/>
      <h1>Ustawienia konta ZONE</h1>
      <div class="forms">
        <label>Adres e-mail</label>
        <input v-model="userEmail" type="email" class="text-input" aria-label="E-mail" placeholder="E-mail"/>
        <div class="buttons-row">
          <button type="button" class="btn btn-link" @click="closeAccountModal">
            Zamknij
          </button>
          <button type="button" class="btn btn-primary" @click="updateUserEmail">
            Zapisz
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsersModel from "@/models/users";
import CloseModalButton from "@/components/common/CloseModalButton";


export default {
  name: "EditAccountModal",
  components: {CloseModalButton},
  data() {
    return {
      userEmail: ''
    }
  },
  methods: {
    async updateUserEmail() {
      const payload = {
        email: this.userEmail
      }
      await UsersModel.updateUserEmail(payload);
      const userData = this.$store.state.currentUserData;
      userData.email = this.userEmail;
      this.$store.commit("setCurrentUserData", userData);
      this.$notify({
        group: 'zone',
        type: 'success',
        title: 'Sukces',
        text: 'Pomyślnie zapisano adres e-mail'
      });
    },
    closeAccountModal() {
      this.$store.commit("closeAccountModal");
    }
  },
  computed: {
    currentUserData() {
      return this.$store.state.currentUserData;
    }
  },
  mounted() {
    this.userEmail = this.currentUserData.email;
  }
}
</script>

<style scoped>
.zone-modal {
  height: 17rem;
  top: 30%;
}

@media screen and (max-width: 768px) {
  .zone-modal {
    width: 96%;
  }
}
</style>
